// Keep the reading destination when requesting another verification email.
export const getVerificationReturnPath = value => {
  if (typeof value !== 'string' || !value) return '/mymanuscripts';
  try {
    const target = new URL(value, window.location.origin);
    if (
      target.origin === window.location.origin &&
      !['/action', '/verify-email', '/signin'].includes(target.pathname)
    ) {
      return target.pathname + target.search + target.hash;
    }
  } catch (e) {
    // Malformed or external destinations fall back to the manuscript list.
  }
  return '/mymanuscripts';
};
